module.exports = __webpack_public_path__ + "static/media/26UNRWA5.db8da6c4.jpg";